import React from "react";

export default function InHousePharmacyNotice(props) {
  return !props.disableInHouseNotice && props.hasInHouseCp ? (
    <div
      className="stat-cards__notice stat-cards__notice--red stat-cards__notice--mb"
      style={{ lineHeight: 1.5 }}
    >
      Our records indicate the selected entity has a pharmacy capable of purchasing and dispensing
      340B drugs to its patients. As a result, the entity is not eligible to designate a single
      contract pharmacy arrangement and any designation you make will not impact access to 340B
      pricing.
      <a href={props.policy_doc_url}>
        <span style={{ fontWeight: 500, textDecoration: "underline", margin: "0px 5px" }}>
          Download Policy document
        </span>
      </a>
      Please reach out to
      <span style={{ fontWeight: 500 }}> support@340besp.com </span>
      for more information or to clarify the entity's ability to dispense 340B purchased drugs to
      patients.
    </div>
  ) : null;
}
